import { render, staticRenderFns } from "./ThemaBearbeiten.vue?vue&type=template&id=e483f680&"
import script from "./ThemaBearbeiten.vue?vue&type=script&lang=js&"
export * from "./ThemaBearbeiten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports